// extracted by mini-css-extract-plugin
export default {"toolTip":"style_toolTip__Ykrbc"};